import { QUESTION_ANIMATION_DURATION_MS } from '../definitions/AnimationDurations';
import getNextFormFocusElement from './getNextFormFocusElement';
import focusFirstInputWithin from './focusFirstInputWithin';
import scrollIntoView from './scrollIntoView';


export default async function focusNextElementInForm(currentQuestionName) {
    // Requirement: Add a delay before proceeding with the scroll
    //  so its clear to the user what they submitted.
    //  A minor delay is also needed to ensure the correct
    //  elements are rendered before we look for the next element.
    await new Promise(resolve => setTimeout(resolve, QUESTION_ANIMATION_DURATION_MS + 50));

    // If we've been unmounted after the timeout and cannot find our own question, just bail
    if (!document.querySelector(`[data-question-name='${currentQuestionName}']`)) {
        return;
    }

    const nextElement = getNextFormFocusElement(currentQuestionName);

    if (!nextElement) {
        throw new Error('[focusNextElementInForm] Cannot find form element after question ' + currentQuestionName);
    }

    // Requirement: Focus submit button when on last question
    if (nextElement.tagName === 'BUTTON') {
        nextElement.focus();
        return true;
    }
    
    await scrollIntoView(nextElement, {
        scrollMode: 'always',
        block: 'start',
        duration: 500,
    });

    focusFirstInputWithin(nextElement);

    return true;
}